
import { Component, ViewChild,OnInit, ViewEncapsulation, TemplateRef, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ImageResult } from 'ngx-image2dataurl';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import  *  as  helpData  from  '../../../data/help/fuel_levy.json';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver';

//Model
import { FuelLevy } from '../../../model/fuellevy.model';
import { ThemeSetting } from '../../../model/users.model';
import { FileExport } from '../../../model/exporter.model';
import { Url } from '../../../model/users.model';

//Service
import { FuelLevyService} from '../../../services/fuellevy.service';
import { DataService } from '../../../services/data.service';
import { ExportService } from '../../../services/exporter.service';
import { NotificationService } from '../../../services/notification.service';
import { PrintService } from '../../../services/print.service';

@Component({
    selector: 'app-fuellevy',
    templateUrl: './fuellevy.component.html',
    styleUrls: ['../../datatable.scss','./fuellevy.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [FuelLevyService]
  })
  
  export class FuelLevyComponent implements OnInit {
    @LocalStorage() url: Url;
    @LocalStorage() themeSettings: ThemeSetting;
    @ViewChild('modalDeleteFuelLevy', {static: false}) modalDeleteFuelLevy: TemplateRef<any>;
    @ViewChild('modalFuelLevy', {static: false}) modalFuelLevy: TemplateRef<any>;


    loadingIndicator: boolean = true;
    rows = [];
    full_rows:any;
    temp:any;
    count: number = 0;
    public user_id: number;

    //Handles the name, type and content of the to-be exported file
    formatted_list : any;
    public exp_excel: FileExport;
    public exp_pdf: FileExport;

    help: any;

    columns = [
        { name: 'id'},
        { prop: 'month' },
        { prop: 'month_name' },
        { prop: 'year' },
        { prop: 'local' },
        { prop: 'linehaul' },
        { prop: 'created_name' },
        { prop: 'updated_name' },
        { prop: 'created_at' },
        { prop: 'updated_at' },
    ];

    showMonth: boolean = true;
    showYear: boolean = true;
    showLocal: boolean = true;
    showLinehaul:boolean = true;
    showCreatedName: boolean = false;
    showCreatedDate: boolean = false;
    showUpdatedName: boolean = false;
    showUpdatedDate: boolean = false;
    
    filterMonth: string ='';
    filterYear: string ='';
    filterLocal: string ='';
    filterLinehaul: string ='';
    filterCreatedName: string ='';
    filterUpdatedName: string ='';
    isFilterEmpty: boolean = true;
    showFilters :boolean = false;
    
    years: number[] = [];
    year_start : number = 2020;
    year_current :number;

    public frm_fuel_levy: FormGroup;
    isEditMode: boolean = false;
    public modalRef: NgbModalRef;

    fuel_levy : FuelLevy;
    month_current : number;
    is_past :boolean  = false;

    constructor(private http: HttpClient, 
        private _fb: FormBuilder, 
        private modal: NgbModal, 
        private svc_fuel_levy: FuelLevyService,
        private data: DataService,
        private exporter: ExportService,
        public printer: PrintService,
        private toaster: NotificationService,
        private svc_storage: LocalStorageService,
        )
    {

        this.year_current = new Date().getFullYear();
        this.month_current = new Date().getMonth();

        for (let year = (this.year_current + 1); year >= this.year_start; year--) {
            this.years.push(year);
        };

    }

    ngOnInit() {
        this.data.currentHelp.subscribe(help => this.help = help);
        this.user_id = this.svc_storage.get('user').id;

        this.getFuelLevies();
        this.initializeForm();

        //Declaration to handle the name, type and content of the file
        this.exp_excel = {title:'', list_data:'', type:''};
        this.exp_pdf = {title:'', list_data:'', type:''};
    }

    ngAfterViewInit() {
        setTimeout(() => { this.data.changeHelp(helpData["default"])});    
    }

    getFuelLevies(){
        this.svc_fuel_levy.getFuelLevies().subscribe(data =>{
            this.rows = data['fuel_levies'];
            this.full_rows = data['fuel_levies'];
            this.count = this.rows?.length;

            setTimeout(() => { this.loadingIndicator = false; }, 1500);
        } );
    }

    public initializeForm(){
        const floatRegex = '^[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$'; 
        this.frm_fuel_levy = this._fb.group({
            id: [''],
            month: ['', Validators.required],
            year: ['', Validators.required],
            // local: [0, [Validators.pattern(floatRegex)]],
            // linehaul: [0, [Validators.pattern(floatRegex)]],
            local: ['', [Validators.required, Validators.min(0.01), Validators.max(100)]],
            linehaul: ['', [Validators.required, Validators.min(0.01), Validators.max(100)]],
            created_by: [this.user_id, Validators.required],
            updated_by: [''],
        });
    }

    openDeleteFuelLevyModal(fuel_levy: FuelLevy): void {
        if(fuel_levy){
            this.fuel_levy = fuel_levy;
          } 
          this.modalRef = this.modal.open(this.modalDeleteFuelLevy, { size: 'md', backdrop: 'static'});
    }

    public deleteFuelLevy(fuel_levy){
        this.svc_fuel_levy.deleteFuelLevy(fuel_levy).subscribe(data=>{
            if(data['error'] == false){
                this.toaster.showSuccess(data['message'], 'Delete Fuel Levy');
                this.getFuelLevies();
            }else{
                this.toaster.showError(data['message'], 'Delete Fuel Levy Error');
            };
        });

        this.closeModal();
    }

    public closeModal(){
      this.modalRef.close();
      this.frm_fuel_levy.reset();
    }

    openFuelLevyModal(fl: FuelLevy): void {
        this.has_record = false;

        if(fl){
          this.isEditMode = true;
          this.fuel_levy = fl;
          this.frm_fuel_levy.patchValue(this.fuel_levy);
          this.frm_fuel_levy.controls.updated_by.setValue(this.user_id);
          this.checkRecords(this.frm_fuel_levy.value);

          //update is_unified based on the value of of local and linehaul fuel levy of the record.
          if(fl.local == fl.linehaul){
              this.is_unified = true;
          }else{
              this.is_unified = false;
          };

          //check if the record is past month year , if yes show alert msg
          if((fl.year < this.year_current) || (fl.year == this.year_current && fl.month < this.month_current) ){
            this.is_past = true;
          }else{
            this.is_past = false;
          }
        } 
        else{
            
          this.isEditMode = false;
          this.fuel_levy = new FuelLevy();
          this.frm_fuel_levy.reset();
          this.initializeForm();
          this.is_past = false;

          //update is_unified based on last most recent record value.
          if(this.rows?.length > 0){
            if(this.rows[0].linehaul == this.rows[0].local){
                this.is_unified = true;
            }else{
                this.is_unified = false;
            }
          }
        }
        
        this.modalRef = this.modal.open(this.modalFuelLevy, { size: 'md', backdrop: 'static'});
      
        this.modalRef.result.then((result) => {
          this.frm_fuel_levy.reset();
        }, (reason) => {
          this.frm_fuel_levy.reset();
        });
      }


    public createFuelLevy(fl: FuelLevy) {
        this.svc_fuel_levy.addFuelLevy(fl).subscribe(result => {
            if(result['error'] == false){
                this.toaster.showSuccess(result['message'], 'Create Fuel Levy');
                this.getFuelLevies();
            }else{
                this.toaster.showError(result['message'], 'Create Fuel Levy Error');
            };
        });
    }

    public updateFuelLevy(fl: FuelLevy) {
        fl.updated_by = this.user_id;
        this.svc_fuel_levy.updateFuelLevy(fl).subscribe(result => {
            if(result['error'] == false){
                this.toaster.showSuccess(result['message'], 'Update Fuel Levy');
                this.getFuelLevies();
            }else{
                this.toaster.showError(result['message'], 'Update Fuel Levy Error');
            };
        });
    }

    public onSubmitFuelLevy(fl: FuelLevy){
        this.fuel_levy = fl;

        if (this.frm_fuel_levy.valid) {
            this.fuel_levy = fl;

            if(fl.id){
                this.updateFuelLevy(this.fuel_levy);
            }
            else{
                this.createFuelLevy(this.fuel_levy);
            }   
    
            this.frm_fuel_levy.reset();
            this.resetFilter();        
        }

        this.closeModal();
    }

    /*** Export... Module ***/
    //Replaces an attribute name for reading comprehension
    renameKey( obj, oldKey, newKey ) {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
    }

    //Filters every column in the table list
    fuellevy_generateColumnsWithFilter(row){
        const arr = JSON.parse(JSON.stringify(row));
        arr.forEach( obj => {

            obj['created_at'] = formatDate(obj['created_at'], 'dd MMM yyyy', 'en_US');
            obj['updated_at'] = formatDate(obj['updated_at'], 'dd MMM yyyy', 'en_US');

            //remove filtered columns
            if(!this.showMonth){
                delete obj['month_name'];
            };
            if(!this.showYear){
                delete obj['year'];
            };
            if(!this.showLocal){
                delete obj['local'];
            };
            if(!this.showLinehaul){
                delete obj['linehaul'];
            };
            if(!this.showCreatedName){
                delete obj['created_name'];
            };
            if(!this.showCreatedDate){
                delete obj['created_at'];
            };
            if(!this.showUpdatedName){
                delete obj['updated_name'];
            };
            if(!this.showUpdatedDate){
                delete obj['updated_at'];
            };
            
            delete obj['id'];
            delete obj['month'];
            delete obj['created_by'];
            delete obj['updated_by'];
        });
        
        const updatedJson = JSON.stringify( arr );
        return updatedJson;                         
    }

    //Formats readable header names in the given table
    generateHeaders(row): any{
        const arr = JSON.parse(row);
        arr.forEach( obj => {
            this.renameKey( obj, 'month_name', 'Month' );
            this.renameKey( obj, 'year', 'Year' );
            this.renameKey( obj, 'local', 'Local' );
            this.renameKey( obj, 'linehaul', 'Linehaul' );
            this.renameKey( obj, 'updated_name', 'Created By' );
            this.renameKey( obj, 'created_at', 'Created Date' );
            this.renameKey( obj, 'updated_name', 'Updated By' );
            this.renameKey( obj, 'updated_at', 'Updated Date' );
        });
        const updatedJson = JSON.stringify( arr );
        return updatedJson;
    }

    //Exports table to CSV file
    fuellevy_exportToCSV(){
        if(this.rows.length >0){
            let with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.fuellevy_generateColumnsWithFilter(this.rows);

            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let csv_file = '[TMS]Fuel_Levy_' + this.formattedDate(current_date);
            this.exporter.exportToCSV(this.formatted_list, csv_file, 'Fuel Levy');
        }
    }

    fuellevy_exportToExcel(){
        if(this.rows.length >0){
        let with_column_filter;
        
        //generate json with filtered column
        with_column_filter = this.fuellevy_generateColumnsWithFilter(this.rows);

        //generate json with format header
        this.formatted_list = this.generateHeaders(with_column_filter);

        //export to file
        let current_date = new Date();
        let excel_file = '[TMS]Fuel_Levy_' + this.formattedDate(current_date);
        this.exp_excel.title = 'Fuel Levy';
        this.exp_excel.type = 'xlsx';
        this.exp_excel.list_data = this.formatted_list;
        this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
            saveAs(data, excel_file)
        });
        }
    }

    fuellevy_exportToPDF(){if(this.rows.length >0){
        let with_column_filter;

        //generate json with filtered column
        with_column_filter = this.fuellevy_generateColumnsWithFilter(this.rows);

        //generate json with format header
        this.formatted_list = this.generateHeaders(with_column_filter);

        //export to file
        let current_date = new Date();
        let pdf_file = '[TMS]Fuel_Levy_' + this.formattedDate(current_date);
        this.exp_pdf.title = 'Fuel Levy';
        this.exp_pdf.type = 'pdf';
        this.exp_pdf.list_data = this.formatted_list;
        this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
            saveAs(data, pdf_file + '.' + this.exp_pdf.type);
        });
        }
    }

    public formattedDate(d = new Date) {
        let month = String(d.getMonth() + 1);
        let day = String(d.getDate());
        const year = String(d.getFullYear());
      
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
      
        return `${day}/${month}/${year}`;
    }


    public showMonthName(number_month){
        var month = "";
        switch(number_month){
            case '1': month = "Jan"; break;
            case '2': month = "Feb"; break;
            case '3': month = "Mar"; break;
            case '4': month = "Apr"; break;
            case '5': month = "May"; break;
            case '6': month = "Jun"; break;
            case '7': month = "Jul"; break;
            case '8': month = "Aug"; break;
            case '9': month = "Sept"; break;
            case '10': month = "Oct"; break;
            case '11': month = "Nov"; break;
            case '12': month = "Dec"; break;
            default: month = ""; break;
        };
        return month;
    }

    updateFilter(status){
        this.isFilterEmpty = false;
        this.rows = this.full_rows;
        this.temp = this.full_rows;
    
        if(this.filterMonth){
            this.temp = this.temp.filter(data => { 
                if (data.month_name !== null && data.month_name !== ''){
                    return data.month_name.toLowerCase().indexOf(this.filterMonth.toLowerCase()) !== -1 || !this.filterMonth.toLowerCase();      
                }else{
                    return data.month_name;
                };
            });  
        };

        if(this.filterYear){
            this.temp = this.temp.filter(data => { 
                if (data.year !== null && data.year !== ''){
                    return data.year.toString().toLowerCase().indexOf(this.filterYear.toLowerCase()) !== -1 || !this.filterYear.toLowerCase();      
                }else{
                    return data.year;
                };
            });  
        };

        if(this.filterLocal){
            this.temp = this.temp.filter(data => { 
                if (data.local !== null && data.local !== ''){
                    return data.local.toString().toLowerCase().indexOf(this.filterLocal.toLowerCase()) !== -1 || !this.filterLocal.toLowerCase();      
                }else{
                    return data.local;
                };
            });  
        };

        if(this.filterLinehaul){
            this.temp = this.temp.filter(data => { 
                if (data.linehaul !== null && data.linehaul !== ''){
                    return data.linehaul.toString().toLowerCase().indexOf(this.filterLinehaul.toLowerCase()) !== -1 || !this.filterLinehaul.toLowerCase();      
                }else{
                    return data.linehaul;
                };
            });  
        };

        if(this.filterCreatedName){
            this.temp = this.temp.filter(data => { 
                if (data.created_name !== null && data.create_name !== ''){
                    return data.created_name.toLowerCase().indexOf(this.filterCreatedName.toLowerCase()) !== -1 || !this.filterCreatedName.toLowerCase();      
                }else{
                    return data.created_name;
                };
            });  
        };

        if(this.filterUpdatedName){
            this.temp = this.temp.filter(data => { 
                if (data.updated_name !== null && data.updated_name !== ''){
                    return data.updated_name.toLowerCase().indexOf(this.filterUpdatedName.toLowerCase()) !== -1 || !this.filterUpdatedName.toLowerCase();      
                }else{
                    return data.updated_name;
                };
            });  
        };

        
        this.rows = this.temp;
        this.count = Object.keys(this.rows).length;
    }

    resetFilter(){
        this.filterMonth = '';
        this.filterYear ='';
        this.filterLocal ='';
        this.filterLinehaul ='';
        this.filterCreatedName ='';
        this.filterUpdatedName ='';
        this.isFilterEmpty = true;
        
        this.rows = this.full_rows;
        this.temp = this.full_rows;
        this.count = Object.keys(this.rows).length;

        this.showFilters = false;
    }

    public toggleFilters() {
        if (this.showFilters) this.showFilters = false;
        else this.showFilters = true;
    }

    has_record: boolean = false;
    checkRecords(fuel_levy){
        var mode = 'create';
        if(fuel_levy.id > 0){
            mode = 'update';
        }

        this.has_record = false; 
        var frm_month = parseInt(fuel_levy.month);
        var frm_year = parseFloat(fuel_levy.year);
        this.rows.forEach(fl=>{
            if(mode == 'create'){
                if(fl.month == frm_month && fl.year == frm_year){
                    this.has_record = true;
                    return this.has_record;
                }
            }else{
                if(fl.month == frm_month && fl.year == frm_year && fuel_levy.id != fl.id){
                    this.has_record = true;
                    return this.has_record;
                }
            }
        })
        
        return this.has_record;
    }

    is_unified :boolean  = false;
    toggleLocalLinehaul(toggle_value){
        this.is_unified = toggle_value;
        if(this.is_unified){
            this.frm_fuel_levy.controls.linehaul.setValue(this.frm_fuel_levy.controls.local.value);
        }
    }

    updateLinehaul(local_value){
        if(this.is_unified){
            this.frm_fuel_levy.controls.linehaul.setValue(local_value.target.value);
        };
    }

}